import { CommonModule } from '@angular/common';
import { Component, Renderer2 } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { CommonService } from '../../../services/common.service';
import { SharedStateService } from '../../../services/shared-state.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, CommonModule],
  templateUrl: './header.component.html',
  styles: ``
})
export class HeaderComponent {
  username: any;
  showThis: boolean = false;
  projectIdMenu: Array<any> = [];
  projectName: Array<any> = [];

  bgColor: string = ''
  avatar: string = ''
  migtypeid: string = ''
  showAdmin: boolean = false;
  moduleData: any
  user: any;
  constructor(
    private router: Router,
    private renderer: Renderer2,
    private common: CommonService,
    public sharedStateService: SharedStateService
  ) {
    this.username = localStorage.getItem('Email')
    this.user = JSON.parse(localStorage.getItem('userData') ?? 'null')
    this.migtypeid = JSON.parse((localStorage.getItem('migtypeid') as string));
    this.moduleData = JSON.parse(localStorage.getItem('module_item') ?? 'null');
  }
  ngOnInit(): void {
    //this.getProjectMenu();
    this.username = localStorage.getItem('Email')
    const getHashOfString = (str: string) => {
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      hash = Math.abs(hash);
      return hash;
    };
    const normalizeHash = (hash: number, min: number, max: number) => {
      return Math.floor((hash % (max - min)) + min);
    };

    const generateHSL = (name: any) => {
      const hash = getHashOfString(name);
      const h = normalizeHash(hash, 0, 360);
      const s = normalizeHash(hash, 3, 255);
      const l = normalizeHash(hash, 9, 255);
      return [h, s, l];
    };
    this.bgColor = generateHSL(this.username).toString()
    let afterDot = this.username.substr(this.username.indexOf('.'));
    this.avatar = this.username.charAt(0) + '' + afterDot.charAt(1)
    //console.log(this.bgColor)

    if (localStorage.getItem("client_id")) {
      this.showThis = true;
    }
    this.moduleRouting();
    this.useraccessByUser()
  }
  logout() {
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate(['/login']);
  }
  toggle() {
    if (document.body.classList.contains("sidebar-icon-only")) {
      this.renderer.removeClass(document.body, "sidebar-icon-only")
    }
    else {
      this.renderer.addClass(document.body, "sidebar-icon-only")
    }
  }
  getProjectMenu() {
    const ProjectId = JSON.parse(localStorage.getItem('project_id') || 'null');
    this.projectIdMenu.length = 0;
    this.common.getProjectMenu(ProjectId).subscribe((res) => {
      this.projectName = res['jsonResponseData']['Table1'];
      this.projectName.forEach((element: any) => {
        this.projectIdMenu.push(element.menu_id);
        //console.log(this.projectIdMenu)
      });
    });
  }
  selectedscreen: any;
  checked(menuscreen: any) {
    localStorage.setItem("menuscreenname", menuscreen);
  }

  moduleCategory: Array<any> = [];
  isAiAdmin: boolean = false;
  moduleRouting() {
    this.moduleCategory.length = 0;
    let modules_value = JSON.parse(localStorage.getItem('module_item') ?? 'null');
    let role_value = JSON.parse(localStorage.getItem('userData') ?? 'null');

    if (modules_value != null) {
      if (typeof modules_value === 'object') {
        modules_value.forEach((element: any) => {
          let module_value = element.slice(2).toLowerCase();
          this.moduleCategory.push(module_value);
        });
      } else {
        let module_value = modules_value.slice(2).toLowerCase();
        this.moduleCategory.push(module_value);
      }
    }
    if ("Administration" in role_value) {
      if (role_value.Administration.length > 0) {
        var dt = role_value.Administration.forEach((element: any) => {
          if (element.includes('role_id:12')) {
            this.isAiAdmin = true
          }
        })
      }
    }
  }

  AdminData: any
  useraccessByUser() {
    let email = this.user.email;
    let useraccessData;
    this.common.getUserAccessByUser(email).subscribe(
      (data) => {
        useraccessData = data['jsonResponseData']['Table1'];
        this.AdminData = useraccessData.filter((item: any) => {
          return item.module_id == "1"
        })
        if (this.AdminData.length != 0) {
          if (this.AdminData[0].status == "Active") {
            this.showAdmin = true;
          }
        }
      },
      (error) => {
        this.showAdmin = false
      }
    );
  }

  isFullscreen: boolean = false;
  toggleFullscreen() {
    const elem = document.documentElement; // or any specific element

    if (!document.fullscreenElement) {
      elem.requestFullscreen?.();
      this.isFullscreen = true;
    } else {
      document.exitFullscreen?.();
      this.isFullscreen = false;
    }
  }
}
